export const formulaToBlob = uri => {
    uri = decodeURIComponent(uri).replace("data:image/svg+xml;charset=utf8,", "");
    const svg = `<?xml version="1.0" encoding="utf-8"?>${uri}`;
    return new Blob([svg], {type: "image/svg+xml;charset=utf-8"});
};
